export enum SupplierTableColumns {
  SUPPLIER_TITLE = 'Supplier',
  SUPPLIER_INDEX = 'name',
  SUPPLIER_SORT_ORDER = 'descend',
  ADDRESS_TITLE = 'Address',
  ADDRESS_INDEX = 'address',
  ADDRESS_SORT_ORDER = 'descend',
  ACTION_TITLE = '',
  ACTION_INDEX = 'actions',
  ACTION_WIDTH = '10%',
}

export enum SupplierProps {
  DELETE_ICON_ALT = 'delete',
  EDIT_ICON_ALT = 'edit',
  LOADING_INDICATOR = 'Loading...',
}

export enum SupplierTableProps {
  DELETE_HEADING = 'Do you want to delete this supplier?',
  DELETE_SUBHEADING = 'By deleting this supplier, it will be permanently removed and you will not be to retrieve it later.',
}

export enum MockData {
  SUPPLIER = 'Supplier',
  street = '123',
  PROVINCE = 'Ontario',
  COUNTRY = 'Canada',
}
